/**
 * @author Christian Künne <christian.kuenne@tomtom.com>
 */

import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './filter-bar-item.module.css'

const propTypesItem = {
    children: PropTypes.node,
    className: PropTypes.string
}

const defaultProps = {
    children: []
}

/**
 * Filter bar items are first level children within a <code><FilterBar/></code> for proper layouting of filter bar
 * content. This component is automatically used as wrapper for each of the provided filter bar children by the filter
 * bar. Therefore it does not need to be used directly as a child within <code><FilterBar/></code> except there is a
 * need for custom styling of a <code><FilterBarItem/></code> with its className property like it is done for the
 * <code><FilterBarSpacer/></code>.
 *
 * @see FilterBar
 * @see FilterBarSpacer
 *
 * @param {Object} props - Component properties object
 * @param {Array|string|ReactElement} [props.children] - The child elements of this component
 * @param {string} [props.className] - A CSS class to append to the component
 * @returns {ReactElement}
 */
function FilterBarItem(props) {
    return (
        <div className={cx(styles['filter-bar-item'], props.className, 't3sel-filter-bar-item')}>{props.children}</div>
    )
}

FilterBarItem.propTypes = propTypesItem
FilterBarItem.defaultProps = defaultProps

export default FilterBarItem
